import { DatagridIconsEdit } from './datagridIconsEdit'
import { DatamapImport } from './datamapImport'
import { ExportDefinition } from './exportDefinition'
import { Form as FeedbackNotificationTemplatesForm } from './feedback/messenger/replyNotificationTemplates/form/form'
import { Form as FeedbackSettingsForm } from './feedback/messenger/settings/form/form'
import { Hierarchy } from './hierarchy'
import { QuestionsOverview } from './questionsOverview'
import { ReportingColorSetting } from './settingsPage/reporting-color/reporting-color.component'
import { TextAnalytics } from './textAnalytics'
import { WysiwygEditor } from './wysiwygEditor'

export const Creator = (() => {
	const hierarchy = Hierarchy()
	const textAnalytics = TextAnalytics()
	const questionsOverview = QuestionsOverview()
	const exportDefinition = ExportDefinition()
	const wysiwygEditor = WysiwygEditor()
	const datamapImport = DatamapImport
	const datagridIconsEdit = DatagridIconsEdit()
	const init = (showModalOverview?: boolean, isAjax?: boolean) => {
		hierarchy.init()
		textAnalytics.init()
		questionsOverview.init()
		wysiwygEditor.init(isAjax)
		exportDefinition.init()
		datamapImport.init(showModalOverview)
		ReportingColorSetting.init()
		datagridIconsEdit.init()
		FeedbackNotificationTemplatesForm.init()
		FeedbackSettingsForm.init()
	}

	return {
		init,
	}
})()
